//====================================================
//  Function: Labels Creat
//====================================================
var counterLabel = 1
var labelResultVisual = $('.js-label-info-result')
var labelGroup = $('.js-labels-group')

function componentLabelsCreate() {
  if ($('.js-labels-group').length) {
    labelGroup = $('.js-labels-group')
    $(document).on('click', '.js-label-add', function () {
      addNewLabel()
      addToLabelsResultCode()
    })

    $(document).on('click', '.js-label-remove', function () {
      if ($('.js-label-item').length > 1) {
        $(this).closest('.js-label-item').remove()
        addToLabelsResultCode()
      }
    })

    $('.js-label-input-title').keyup(function () {
      addToLabelsResultCode()
    })

    $(document).on(
      'keyup',
      '.js-label-input-link, .js-label-input-alt, .js-label-input-src',
      function () {
        addToLabelsResultCode()
      },
    )
  }
}

function addToLabelsResultCode() {
  var arrayResultLabels = []
  var arrayResultLabelsString = ''
  var templateBoxHeader = `
    <div class="content-wrapper partners-block js-partners-block">
  `
  arrayResultLabels.push(templateBoxHeader)

  var inputTitle = $('.js-label-input-title')
  var inputTitleValue = inputTitle.val()
  var templateBoxtitle = `
      <div class="h4 homepage-group-title">${inputTitleValue}</div>
      <div class="container">
        <div class="partners-group">
  `

  arrayResultLabels.push(templateBoxtitle)

  $('.js-label-item').each(function () {
    var element = $(this)
    var labelSrc = element.find('.js-label-input-src').val()
    var labelAlt = element.find('.js-label-input-alt').val()
    var labelLink = element.find('.js-label-input-link').val()
    if (labelLink.length == 0) {
      var templateBoxItem = `
        <div class="partners__item">
          <div class="partners__content">
            <div class="partners__image-block">
              <img src="${labelSrc}" alt="${labelAlt}" title="${labelAlt}" loading="lazy">
            </div>
          </div>
        </div>
      `
    } else {
      var templateBoxItem = `
        <div class="partners__item">
          <a class="partners__content" href="/${labelLink}/">
            <div class="partners__image-block">
              <img src="${labelSrc}" alt="${labelAlt}" title="${labelAlt}" loading="lazy">
            </div>
          </a>
        </div>
      `
    }

    // if (checkboxValue === 'false' || checkboxValue === '"left"') {
    //   return false
    // }
    arrayResultLabels.push(templateBoxItem)
  })

  var templateBoxFooter = `
        </div>
      </div>
    </div>
  `

  //  $('.js-label-info-result')[0].outerHTML.replace(/(\r\n|\n|\r)/gm, "");
  arrayResultLabels.push(templateBoxFooter)
  arrayResultLabels = arrayResultLabels.join(' ')

  console.log(arrayResultLabels)

  labelResultVisual.empty()
  labelResultVisual.append(arrayResultLabels)

  arrayResultLabelsString = $(
    '.js-label-info-result .js-partners-block',
  )[0].outerHTML.replace(/(\r\n|\n|\r)/gm, '')

  // console.log(arrayResultLabelsString)
  // console.log(typeof arrayResultLabelsString)
  $('.js-code-result').empty()
  $('.js-code-result').text(arrayResultLabelsString)
}

function addNewLabel() {
  counterLabel++
  if ($('html.is-sk').length) {
    var newLabelTemplate = `
    <div class="labels-group__item js-label-item" data-id="${counterLabel}">
        <div class="labels-group__content">
          <div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
            <h2 class="delta">Značka</h2>
          </div>
          <div class="row gutter-10 margin-bottom-1-2 align-items-center">
            <div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
              <label class="form__label form__label--classic" for="label_${counterLabel}_src">Odkaz na obrázok</label>
            </div>
            <div class="col-12 col-sm-7 col-xl-8">
              <div class="label__input">
                <input class="form__input form__input--small form__input--outline js-label-input-src" type="text" id="label_${counterLabel}_src" name="label_${counterLabel}_src" value="https://cdn.myshoptet.com/usr/apollo.jakubtursky.sk/user/documents/upload/logo/apple.png">
              </div>
            </div>
          </div>
          <div class="row gutter-10 margin-bottom-1-2 align-items-center">
            <div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
              <label class="form__label form__label--classic" for="label_${counterLabel}_alt">Popisny text pre obrázok ( nepovinné )</label>
            </div>
            <div class="col-12 col-sm-7 col-xl-8">
              <div class="label__input">
                <input class="form__input form__input--small form__input--outline js-label-input-alt" type="text" id="label_${counterLabel}_alt" name="label_${counterLabel}_alt" value="Apple logo">
              </div>
            </div>
          </div>
          <div class="row gutter-10 margin-bottom-1-2 align-items-center">
            <div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
              <label class="form__label form__label--classic" for="label_${counterLabel}_link">Odkaz na podstránku ( nepovinné )</label>
            </div>
            <div class="col-12 col-sm-7 col-xl-8">
              <div class="label__input">
                <input class="form__input form__input--small form__input--outline js-label-input-link" type="text" id="label_${counterLabel}_link" name="label_${counterLabel}_link" value="mobilne-telefony">
              </div>
            </div>
          </div>
          <div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
            <div class="col-12 txt-r">
              <div class="label__action justify-content-end">
                <div class="label__add js-label-add">
                      <svg class="icon-svg icon-plus">
                        <use xlink:href="images/sprites.svg#icon-plus"></use>
                      </svg><span>Pridať značku</span>
                </div>
                <div class="label__remove js-label-remove">
                      <svg class="icon-svg icon-close">
                        <use xlink:href="images/sprites.svg#icon-close"></use>
                      </svg><span>Odobrať značku</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  `
  }
  if ($('html.is-hu').length) {
    var newLabelTemplate = `
				<div class="labels-group__item js-label-item" data-id="${counterLabel}">
						<div class="labels-group__content">
							<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
								<h2 class="delta">Márka</h2>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
								<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
									<label class="form__label form__label--classic" for="label_${counterLabel}_src">Link a képhez</label>
								</div>
								<div class="col-12 col-sm-7 col-xl-8">
									<div class="label__input">
										<input class="form__input form__input--small form__input--outline js-label-input-src" type="text" id="label_${counterLabel}_src" name="label_${counterLabel}_src" value="https://cdn.myshoptet.com/usr/apollo.jakubtursky.sk/user/documents/upload/logo/apple.png">
									</div>
								</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
								<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
									<label class="form__label form__label--classic" for="label_${counterLabel}_alt">A képhez tartozó leíró szöveg ( opcionális )</label>
								</div>
								<div class="col-12 col-sm-7 col-xl-8">
									<div class="label__input">
										<input class="form__input form__input--small form__input--outline js-label-input-alt" type="text" id="label_${counterLabel}_alt" name="label_${counterLabel}_alt" value="Apple logo">
									</div>
								</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
								<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
									<label class="form__label form__label--classic" for="label_${counterLabel}_link">Link az aloldalra ( opcionális )</label>
								</div>
								<div class="col-12 col-sm-7 col-xl-8">
									<div class="label__input">
										<input class="form__input form__input--small form__input--outline js-label-input-link" type="text" id="label_${counterLabel}_link" name="label_${counterLabel}_link" value="mobiltelefonok">
									</div>
								</div>
							</div>
							<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
								<div class="col-12 txt-r">
									<div class="label__action justify-content-end">
										<div class="label__add js-label-add">
													<svg class="icon-svg icon-plus">
														<use xlink:href="images/sprites.svg#icon-plus"></use>
													</svg><span>Márka hozzáadása</span>
										</div>
										<div class="label__remove js-label-remove">
													<svg class="icon-svg icon-close">
														<use xlink:href="images/sprites.svg#icon-close"></use>
													</svg><span>Unmark</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
			`
  }
  labelGroup.append(newLabelTemplate)
}
